import React from "react";
import { MdBiotech } from "react-icons/md";
import { FaGraduationCap } from "react-icons/fa";
import { MdMilitaryTech } from "react-icons/md";
import tailwindIcon from "../assets/tech-stack/Tailwind.png";
import JSIcon from "../assets/tech-stack/Javascript.svg";
import reactIcon from "../assets/tech-stack/React.png";
import gitIcon from "../assets/tech-stack/Git.svg";
import typescriptIcon from "../assets/tech-stack/typescript.svg";
import javaIcon from "../assets/tech-stack/java.svg";
import springBootIcon from "../assets/tech-stack/spring-boot.svg";
import leetcodeIcon from "../assets/tech-stack/LeetCode_logo_black.svg";
import sqlIcon from "../assets/tech-stack/Azure SQL Database.svg";
import postmanIcon from "../assets/tech-stack/postman.svg";

const Skills = () => {
  return (
    <div className="mx-3 sm:mx-12">
      <div className="max-w-[1200px] mx-auto flex flex-col sm:gap-4 lg:gap-0 lg:flex-row justify-between items-center py-8 overflow-hidden">
        {/* left side */}
        <div className="flex flex-col gap-4 sm:gap-8">
          {/* heading */}
          <h2 className="text-[#e84949] text-5xl font-medium skills-heading">
            Me and <br /> MyTech Stack
          </h2>

          {/* description */}
          <div className="flex flex-col gap-2 sm:gap-3 skills-description">
            {/* education */}
            <div className="flex flex-col">
              <h2 className="flex gap-1 items-center text-[#e84949]">
                <FaGraduationCap /> <span>Graduation</span> <br />
              </h2>
              <ul className="list-disc ml-10 small-screen-margin-set">
                <li>
                  Bachelor's in Computer Application from Saurashtra University,
                  Rajkot
                </li>
              </ul>
            </div>

            {/* awards */}
            <div className="flex flex-col">
              <h2 className="flex gap-1 items-center text-[#e84949]">
                <MdMilitaryTech /> <span>Achievements</span>
              </h2>
              <ul className="list-disc ml-10 small-screen-margin-set">
                <li>
                  I have solved{" "}
                  <span className="text-[#e84949]">
                    175+ Leetcode Questions
                  </span>{" "}
                  of various DataStructures.
                </li>
                <li>
                  Achieved a CGPA of{" "}
                  <span className="text-[#e84949]">8.81</span> in my last
                  semester and ranked first.
                </li>
                <li>
                  Consistently maintained a CGPA above{" "}
                  <span className="text-[#e84949]">8.5</span> throughout other
                  semesters.
                </li>
              </ul>
            </div>

            {/* technical skills */}
            <div className="flex flex-col">
              <h2 className="flex gap-1 items-center text-[#e84949]">
                <MdBiotech /> <span>Tech Skills</span>
              </h2>
              <ul className="list-disc ml-10 small-screen-margin-set">
                <li>HTML/CSS, Tailwind, Material UI, Chakra UI</li>
                <li>
                  JavaScript, Typescript,
                  <span className="text-[#e84949]">ReactJS, NextJS</span>
                </li>
                <li>Redux, React Query, React Hook Form</li>
                <li>
                  <span className="text-[#e84949]">Java</span>,
                  <span className="text-[#e84949]"> Spring Boot</span>,{" "}
                  <span className="text-[#e84949]">SQL</span>
                </li>
                <li>Git, GitHub, Postman</li>
              </ul>
            </div>
          </div>
        </div>

        {/* right side */}
        <div className="relative p-8 animated-tech-stack-container">
          {/* animated-outer-circle */}
          <div className="h-96 w-96 rounded-full border relative animate-outer-circle ">
            <div className="h-12 bg-white absolute right-16 top-[3%] animate-skills-icons">
              <img className="h-12 object-contain" src={javaIcon} alt="java" />
            </div>
            <div className="h-12 bg-white absolute -right-6 top-[50%] -translate-y-1/2 animate-skills-icons">
              <img
                className="h-12 object-contain"
                src={springBootIcon}
                alt="spring-boot"
              />
            </div>
            <div className="h-12 bg-white absolute right-16 bottom-[3%] animate-skills-icons">
              <img
                className="h-12 object-contain"
                src={leetcodeIcon}
                alt="leetcode"
              />
            </div>
            <div className="h-12 bg-white absolute left-16 bottom-[3%] animate-skills-icons">
              <img className="h-12 object-contain" src={sqlIcon} alt="sql" />
            </div>
            <div className="h-12 bg-white absolute -left-6 top-[50%] -translate-y-1/2 animate-skills-icons">
              <img className="h-12 object-contain" src={gitIcon} alt="git" />
            </div>
            <div className="h-12 bg-white absolute left-16 top-[3%] animate-skills-icons">
              <img
                className="h-12 object-contain"
                src={postmanIcon}
                alt="postman"
              />
            </div>

            {/* animated-inner-circle */}
            <div className="h-72 w-72 bg-gray-200 rounded-full absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 ">
              <div className="h-44 w-44 bg-white rounded-full absolute top-[20%] left-[20%] animate-inner-circle">
                <img
                  className="h-7 object-contain absolute right-3 top-[3%] animate-inner-skills-icons"
                  src={JSIcon}
                  alt="javascript"
                />
                <img
                  className="h-9 object-contain absolute right-3 bottom-[3%] animate-inner-skills-icons"
                  src={typescriptIcon}
                  alt="typescript"
                />
                <img
                  className="h-9 object-contain absolute left-3 top-[3%] animate-inner-skills-icons"
                  src={tailwindIcon}
                  alt="tailwind"
                />
                <img
                  className="h-8 object-contain absolute left-3 bottom-[3%] animate-inner-skills-icons"
                  src={reactIcon}
                  alt="react"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
